import { george, pr, theme } from "aaa";
import { ChooseAddressEmbedded } from "components/common/ChooseAddress";
import { ChooseEmailEmbedded } from "components/common/ChooseEmail";
import { LightSeparatorLine } from "components/util/primitives";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import { themeColors } from "muiTheme";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString } from "types/amount";
import { getDefaultKeyPressHandler } from "util/helpers";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

export const CardTanSettingsNewDevice = observer(({ store }: { store: CardTanSettingsStore }) => {
    const [didAutofocus, setDidAutofocus] = React.useState(false);
    const [isOfferLoaded, setIsOfferLoaded] = React.useState(false);
    const [isApprovalChecked, setApprovalIsChecked] = React.useState(false);

    const handleClickSign = async () => {
        try {
            await store.orderNewDevice();

            pushRoute(CardTanSettingsRoutes.NEW_DEVICE_SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    const handleBack = async () => {
        // reset changes
        // store.updatedDebitCards = store.debitCards;
        pushRoute(CardTanSettingsRoutes.ROOT);
    };

    const ref = React.useRef<HTMLAnchorElement | null>(null);

    React.useEffect(() => {
        if (ref.current && !didAutofocus) {
            ref.current.focus();
            setDidAutofocus(true);
        }

    }, []);

    const isLoadingOfferFinished = store.isLoadingCardTanReaderOfferFinished;
    const hasCardTanReaderOffer = !!store.offersStore.findByChannelProduct("CARDTAN-READER");

    React.useEffect(() => {
        if (isLoadingOfferFinished && !hasCardTanReaderOffer) {
            pushRoute(CardTanSettingsRoutes.NEW_DEVICE_ERROR_NO_OFFER);
        }
    }, [isLoadingOfferFinished, hasCardTanReaderOffer]);

    if (store.isLoading || store.isLoadingCardTanReaderOfferAndPrice || !isLoadingOfferFinished || !hasCardTanReaderOffer) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.Background>
            <george.PageWithActionButton>
                <div style={{ padding: theme.MARGIN }}>
                    <a
                        ref={ref}
                        style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", cursor: "pointer" }}
                        role="button"
                        tabIndex={0}
                        onClick={handleBack}
                        onKeyPress={getDefaultKeyPressHandler(handleBack)}
                        aria-label={ui.__("a11y.back")}
                    >
                        <pr.IconChevronLeft style={{ color: "#135EE2" }} />
                        {!externalInterfaceStore.isGeorgeApp && (
                            <pr.P_16_CONTENT style={{ color: "#135EE2", fontWeight: 600 }}>
                                {ui.__("common.back")}
                            </pr.P_16_CONTENT>
                        )}
                    </a>
                    <pr.P_24_TITLE style={{ fontWeight: 700, marginTop: theme.MARGIN }}>
                        {ui.__("cardTanSettings.setting.newDevice")}
                    </pr.P_24_TITLE>
                    <pr.P_16_CONTENT style={{ color: ui.isDarkMode ? "white" : "#0A285C", lineHeight: "22px", marginTop: 16 }}>
                        {ui.__("cardTanSettings.newDevice.description")}
                    </pr.P_16_CONTENT>
                    <div className="theme-paper" style={{ borderRadius: 8, border: ui.isDarkMode ? undefined : `1px solid ${themeColors.grey_200}`, marginTop: 16 }}>
                        <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", padding: 16 }}>
                            {ui.__("cardTanSettings.newDevice.orderDetails.title")}
                        </pr.P_18_TITLE>
                        <LightSeparatorLine />
                        <div style={{ padding: 16 }}>
                            <pr.P_14_CONTENT style={{ lineHeight: "20px" }}>
                                {ui.__("cardTanSettings.newDevice.orderDetails.device.label")}
                            </pr.P_14_CONTENT>
                            <pr.P_16_TITLE style={{ fontWeight: 600, lineHeight: "22px" }}>
                                {ui.__("cardTanSettings.newDevice.orderDetails.device.text")}
                            </pr.P_16_TITLE>
                            <pr.P_14_CONTENT style={{ lineHeight: "20px", marginTop: 12 }}>
                                {ui.__("cardTanSettings.newDevice.orderDetails.price.label")}
                            </pr.P_14_CONTENT>
                            <pr.P_16_TITLE style={{ fontWeight: 600, lineHeight: "22px" }}>
                                {amountToCurrencyString(store.cardTanReaderUnitPrice)}
                            </pr.P_16_TITLE>
                        </div>
                    </div>
                    <div className="theme-paper" style={{ borderRadius: 8, border: ui.isDarkMode ? undefined : `1px solid ${themeColors.grey_200}`, marginTop: 16 }}>
                        <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", padding: 16 }}>
                            {ui.__("cardTanSettings.newDevice.personalData.title")}
                        </pr.P_18_TITLE>
                        <LightSeparatorLine />
                        <div style={{ padding: 16 }}>
                            <ChooseAddressEmbedded
                                description={ui.__("cardTanSettings.newDevice.description")}
                                contactsStore={store.contactsStore}
                                onNewAddress={() => pushRoute(CardTanSettingsRoutes.NEW_ADDRESS)}
                                onUpdateAddress={() => pushRoute(CardTanSettingsRoutes.UPDATE_ADDRESS)}
                            />
                        </div>
                        <LightSeparatorLine />
                        <div style={{ padding: 16 }}>
                            <ChooseEmailEmbedded
                                contactsStore={store.contactsStore}
                                description={ui.__("cardTanSettings.newDevice.personalData.email.description")}
                            />
                        </div>
                    </div>
                    <div className="theme-paper" style={{ borderRadius: 8, border: ui.isDarkMode ? undefined : `1px solid ${themeColors.grey_200}`, marginTop: 16 }}>
                        <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", padding: 16 }}>
                            {ui.__("cardTanSettings.newDevice.approval.title")}
                        </pr.P_18_TITLE>
                        <LightSeparatorLine />
                        <div style={{ padding: 16 }}>
                            <george.ApprovalEmbedded
                                hideTitle
                                onCheck={(event, checked) => setApprovalIsChecked(checked)}
                                message={ui.__("cardTanSettings.newDevice.approval.text")}
                            />
                        </div>
                    </div>
                </div>
                <george.ActionButton
                    onClick={handleClickSign}
                    primary
                    messageId="button.continue"
                    disableButton={!isApprovalChecked || !store.contactsStore.selectedAddressId || !store.contactsStore.selectedEmailAddressId}
                    isLoading={store.isLoading}
                />
            </george.PageWithActionButton>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsNewDevice.tsx